import React from "react";
import {
  ProgressBar,
  Intent,
  Toaster,
  Position,
  Card,
  InputGroup
} from "@blueprintjs/core";
import { base } from "../fire";
import Auth from "../services/Auth";
import Loader from 'components/layout/loaders/Classic'
import SessionTable from "../components/Home/SessionTable";
import Session from "../services/Session";
import NotAllowedMessage from 'components/Home/NotAllowedMessage';
import NonIdeal from 'components/layout/nonIdeal/Classic'
import { translate } from "utlis/translations/i18n";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      user: false,
      sessions: [],
      filteredSessions: [],
      filterValue: "",
    };
    this.baseEndpoint = `sessions`;
  }

  toast_uploadInProgress = (text, progress, timeout) => ({
    icon: "cloud-upload",
    message: (
      <div>
        <ProgressBar
          intent={progress < 100 ? Intent.NONE : Intent.SUCCESS}
          value={progress / 100}
        />
        <div className="text-center">{text}</div>
      </div>
    ),
    timeout: timeout
  });

  handleDeleteSession = sessionId => {
    let { sessions } = this.state;
    const sessionToDelete = sessions.find(s => s.id === sessionId);
    const progressToastKey = this.toaster.show(
      this.toast_uploadInProgress("Delete session images", 10, 0)
    );
    Session.deleteSequencesInStorage(sessionToDelete)
      .then(() => {
        if (this.toaster)
          this.toaster.show(
            this.toast_uploadInProgress(
              "Delete introduction images",
              50,
              0
            ),
            progressToastKey
          );
      })
      .then(() => {
        if (this.toaster)
          this.toaster.show(
            this.toast_uploadInProgress("Deletion in progress", 20, 2000),
            progressToastKey
          );
      })
      .then(() => Session.deleteInterludesInStorage(sessionToDelete))
      .then(() => {
        if (this.toaster)
          this.toaster.show(
            this.toast_uploadInProgress("Deletion in progress", 40, 2000),
            progressToastKey
          );
      })
      .then(() => Session.deleteInstances(sessionToDelete))
      .then(() => {
        if (this.toaster)
          this.toaster.show(
            this.toast_uploadInProgress("Deletion in progress", 60, 2000),
            progressToastKey
          );
      })
      .then(() => Session.deleteChannelsInStorage(sessionToDelete))
      .then(() => {
        if (this.toaster)
          this.toaster.show(
            this.toast_uploadInProgress("Deletion in progress", 80, 2000),
            progressToastKey
          );
      })
      .then(() =>
        this.setState({ sessions: sessions.filter(s => s.id !== sessionId) })
      )
      .then(() => {
        if (this.toaster)
          this.toaster.show(
            this.toast_uploadInProgress("Deletion over !", 100, 2000),
            progressToastKey
          );
      })
      .catch(e => console.error("Unable to delete session", e.message));
  };

  handleDeleteResults = (sessionId) => {
    let { sessions } = this.state;
    const sessionToDelete = sessions.find(s => s.id === sessionId);
    const progressToastKey = this.toaster.show(
      this.toast_uploadInProgress("Deleting results", 10, 0)
    );
    Session.deleteInstances(sessionToDelete)
      .then(() => {
        if (this.toaster)
          this.toaster.show(
            this.toast_uploadInProgress("Deletion over !", 100, 2000),
            progressToastKey
          );
      })
      .catch(e => console.error("Unable to delete session results", e.message));
  };

  handleChangeSessionStatus = (sessionId, newStatus) => {
    let { sessions } = this.state;

    sessions.find(s => {
      if (s.id !== sessionId) return null;
      return (s.metadata.status = newStatus);
    });
    this.setState({ sessions });
  };

  handleDuplicateSession = session => {
    const userId = Auth.getUserId();
    const endpoint = `sessions/${userId}/${session.id}`;
    const progressToastKey = this.toaster.show(
      this.toast_uploadInProgress("Launching the copy...", 0, 0)
    );
    let createdSessionData = null;

    base
      .fetch(endpoint, {})
      .then(sessionData => {
        // Some properties won't be dulicated or have to be edited
        sessionData.metadata.shortname = "";
        sessionData.data.sequences = [];
        sessionData.metadata.createdDate = Date.now();
        sessionData.metadata.rebrandLinkId = null;
        sessionData.metadata.shortUrl = null;
        return sessionData;
      })
      .then(sessionData => Session.createSession(sessionData))
      .then(({ firebaseData }) => (createdSessionData = firebaseData))
      .then(() => {
        if (this.toaster)
          this.toaster.show(
            this.toast_uploadInProgress("Copy done !", 100, 2000),
            progressToastKey
          );
        // Let's duplicate sequence resources
        const { data, id } = createdSessionData;
        const { sequencesResources } = data;
        // Let's duplicate all resource files
        const promises = sequencesResources.map(
          r =>
            new Promise(resolve => {
              const xhr = new XMLHttpRequest();

              xhr.responseType = "blob";
              xhr.onload = () => {
                const fileRef = Session.addResource({
                  sessionId: id,
                  resource: { file: r.file, fileBlob: xhr.response },
                  onComplete: () => {
                    fileRef
                      .getDownloadURL()
                      .then(url => (r.downloadURL = url))
                      .then(() => resolve());
                  }
                });
              };
              xhr.open("GET", r.downloadURL);
              xhr.send();
            })
        );
        return Promise.all(promises).then(() => sequencesResources);
      })
      .then(sequencesResources =>
        Session.updateSequencesResources(
          createdSessionData.id,
          sequencesResources
        )
      )
      .then(() => {

        // Let's duplicate interlude resources
        const { data, id } = createdSessionData;
        const { interludes } = data;

        if (!interludes) return [];
        // Let's duplicate all resource files
        const promises = interludes.map(
          i =>
            new Promise(resolve => {
              const xhr = new XMLHttpRequest();

              xhr.responseType = "blob";
              xhr.onload = () => {
                const fileRef = Session.addInterlude({
                  sessionId: id,
                  interlude: { file: i.file, fileBlob: xhr.response },
                  onComplete: () => {
                    fileRef
                      .getDownloadURL()
                      .then(url => (i.downloadURL = url))
                      .then(() => resolve());
                  }
                });
              };
              xhr.open("GET", i.downloadURL);
              xhr.send();
            })
        );
        return Promise.all(promises).then(() => interludes);
      })
      .then(interludes =>
        Session.updateInterludes(createdSessionData.id, interludes)
      )
      .then(() => {
        const { data, id, metadata } = createdSessionData;
        const { mcCriterias = [] } = data;

        if (metadata.protocol !== "MC" /* USE CONSTANTS */) return;
        if (mcCriterias.length === 0) return;
        // Let's duplicate all channel image
        const promises = mcCriterias.map(
          channel =>
            new Promise(resolve => {
              const xhr = new XMLHttpRequest();

              xhr.responseType = "blob";
              xhr.onload = () => {
                const fileRef = Session.addChannelCriteriaImage({
                  sessionId: id,
                  criteria: { file: channel.file, fileBlob: xhr.response },
                  onComplete: () => {
                    fileRef
                      .getDownloadURL()
                      .then(url => (channel.downloadURL = url))
                      .then(() => resolve());
                  }
                });
              };
              xhr.open("GET", channel.downloadURL);
              xhr.send();
            })
        );
        return Promise.all(promises).then(() => mcCriterias);
      })
      .then(mcCriterias =>
        Session.updateChannelCriterias(createdSessionData.id, mcCriterias)
      )
      .catch(e => console.error(e));
  };

   // Ajout de handleFilterChange
   handleFilterChange = (e) => {
    const { sessions } = this.state;
    const filterValue = e.target.value.toLowerCase();
    // Nouveau tableau contenant les sessions filtrées
    const filteredSessions = sessions.filter((session) => {
      return (
        session.metadata.name &&
        session.metadata.name.toLowerCase().includes(filterValue)
      );
    });
    this.setState({ filteredSessions, filterValue });
  };

  render() {

    const { loading, sessions, user, filteredSessions } = this.state;

    if (loading) return (
      <Loader />
    )

    if (user.isNotAllowed) return (
      <NotAllowedMessage />
    )

    return (
      <Card>
        <Toaster
          position={Position.TOP_RIGHT}
          ref={toaster => (this.toaster = toaster)}
        />
         {/* Ajout de l'input de filtre via un composant bluePrint*/}
         <InputGroup
          id="filterInput"
          leftIcon="filter"
          onChange={this.handleFilterChange}
          // placeholder="Enter the name of the session you are looking for..."
          placeholder={translate("filterInput.placeholder")}
          value={this.state.filterValue}
          style={{ marginBottom: "20px" }}
        />
        <div className="row">
          {(sessions == null || sessions.length <= 0) && (
            <NonIdeal
              title="It's empty..."
              desc="You did not create session yet."
              url="/create"
              icon="hand"
              buttonIntent={Intent.PRIMARY}
            />
          )}
          {sessions != null && sessions.length > 0 && (
            <div className="col-xs-12">
              <Card>
                <SessionTable
                  // Modification de la props sessions en y ajoutant filteredSessions en affichage conditionnel
                  sessions={
                    filteredSessions === null || filteredSessions.length === 0
                      ? sessions
                      : filteredSessions
                  }
                  onDeleteSession={this.handleDeleteSession}
                  onDeleteResults={this.handleDeleteResults}
                  onChangeSessionStatus={this.handleChangeSessionStatus}
                  onDuplicateSession={this.handleDuplicateSession}
                />
              </Card>
            </div>
          )}
        </div>
      </Card>
    );
  }

  componentWillMount() {
    const endpoint = `${this.baseEndpoint}/${Auth.getUserId()}`;
    this.setState({ user: Auth.getUser() })
    this.syncSessionsRef = base.syncState(endpoint, {
      context: this,
      state: "sessions",
      asArray: true,
      keepKeys: true,
      then: () => this.setState({ loading: false })
    });
  }

  componentWillUnmount() {
    if (this.syncSessionsRef) base.removeBinding(this.syncSessionsRef);
  }
}

export default Home;